import React from 'react';
import MultiSelectButton from '../shared/MultiSelectButton';
import { WEEKDAYS, getMaxSelection } from '../onboardingQuestions';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const IntensiveDaysStep: React.FC<StepProps> = ({ answer, onAnswer, answers }) => {
  const selected: number[] = Array.isArray(answer) ? answer : [];
  const maxSel = getMaxSelection('intensive_workout_days_preference', answers);

  const toggle = (val: number) => {
    if (selected.includes(val)) {
      onAnswer(selected.filter((v) => v !== val));
    } else if (selected.length < maxSel) {
      onAnswer([...selected, val]);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
        {WEEKDAYS.map((day) => (
          <MultiSelectButton
            key={day.value}
            label={day.label}
            value={day.value}
            selected={selected.includes(day.value as number)}
            onClick={() => toggle(day.value as number)}
            disabled={!selected.includes(day.value as number) && selected.length >= maxSel}
          />
        ))}
      </div>
      <p style={{
        fontFamily: "'Figtree', sans-serif",
        fontSize: 14,
        color: 'rgba(250,253,251,0.5)',
        textAlign: 'center',
        margin: '8px 0 0',
      }}>
        Select up to {maxSel} {maxSel === 1 ? 'day' : 'days'}
      </p>
    </div>
  );
};

export default IntensiveDaysStep;
